import { render, staticRenderFns } from "./Partiya.vue?vue&type=template&id=c2c84cde&scoped=true"
import script from "./Partiya.vue?vue&type=script&lang=js"
export * from "./Partiya.vue?vue&type=script&lang=js"
import style0 from "./Partiya.vue?vue&type=style&index=0&id=c2c84cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c84cde",
  null
  
)

export default component.exports